import { loggerFor } from '@app/utils/logger';

interface StoppableEventHandler<K extends keyof WindowEventMap> {
  start(): void;
  (event: WindowEventMap[K]): void;
  stop(): void;
}

export function stoppableEventHandler<K extends keyof WindowEventMap>(
  element: Document | HTMLElement | Window,
  event: K,
  callback: (event: WindowEventMap[K]) => void
): StoppableEventHandler<K> {
  const fn = (event: WindowEventMap[K]) => callback(event);
  const logger = loggerFor(`StoppableEventHandler ${event}`);

  fn.start = () => {
    logger.debug('Starting listener');
    element.addEventListener(event, fn);
  };

  fn.stop = () => {
    logger.debug('Stopping listener');
    element.removeEventListener(event, fn);
  };

  return fn;
}
